import { Factory, FlaskConical, BadgeCheck, Truck, ShieldCheck, HeartPulse } from "lucide-react";
import { Reveal } from "@/components/motion";

const BADGES = [
  { icon: Factory, title: "Made in WHO-GMP", sub: "Certified Facilities" },
  { icon: FlaskConical, title: "Lab Tested", sub: "Formulations" },
  { icon: BadgeCheck, title: "100% Authentic", sub: "Quality Assured" },
  { icon: Truck, title: "Fast Express", sub: "Dispatch" },
  { icon: ShieldCheck, title: "FDA Compliant", sub: "Standards" },
  { icon: HeartPulse, title: "Non-Habit", sub: "Forming" },
];

export default function TrustBadges() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-8 py-16" data-testid="trust-badges-section">
      <Reveal>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center">
          Pharmaceutical Wellness That <span className="text-emerald-800">Nourishes & Heals</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-4 mt-10">
        {BADGES.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.06}>
            <div className="flex flex-col items-center text-center gap-2 p-4 rounded-2xl bg-white border border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all duration-300" data-testid={`trust-badge-${i}`}>
              <span className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-700">
                <b.icon size={22} strokeWidth={1.7} />
              </span>
              <p className="text-xs font-bold text-slate-800 leading-tight whitespace-nowrap">{b.title}</p>
              <p className="text-[10px] text-slate-500 leading-tight -mt-1">{b.sub}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
